var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:[
        'tw:w-full tw:px-4 tw:py-3 tw:text-sm tw:text-slate-700 tw:bg-white tw:border tw:border-slate-200 tw:rounded-xl tw:shadow-sm',
        'tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-brand-primary/20 tw:focus:border-brand-primary',
        'tw:transition-all tw:resize-y tw:disabled:bg-slate-100 tw:disabled:border-slate-200 tw:disabled:text-slate-400',
        _vm.customClass
    ],attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows,"disabled":_vm.disabled,"required":_vm.required},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }